export const ACTION_CARD_CHART_DATA = [
	{ value: 0 },
	{ value: 35 },
	{ value: 100 },
	{ value: 180 },
	{ value: 90 },
	{ value: 150 },
	{ value: 100 },
	{ value: 140 },
	{ value: 200 },
];

export const CHART_GRADIENT_CONFIG = {
	id: 'chartGradient',
	x1: '0',
	y1: '0',
	x2: '0',
	y2: '1',
	stops: [
		{ offset: '0%', color: 'var(--gradient-chart-start)', opacity: 0.85 },
		{ offset: '100%', color: 'var(--gradient-chart-end)', opacity: 0.1 },
	],
};

export const CHART_MARGIN = { top: 5, right: 0, left: 0, bottom: 5 };
